/* eslint-disable react/button-has-type */
/* eslint-disable max-len */
import React from 'react';
import { node, oneOf, string } from 'prop-types';
import clsx from 'clsx';
import { buttonLengthConstants, buttonVariantConstants } from '../../common/constants';

const ButtonRegular = (props) => {
  const {
    children,
    className,
    length = buttonLengthConstants.SHORT,
    theme = null,
    type = 'button',
    variant = buttonVariantConstants.PRIMARY_CERULEAN,
    ...buttonProps
  } = props;

  const baseClasses =
    'text-center font-brown text-[10px] lg:text-xs not-italic font-bold leading-4 lg:leading-5 tracking-[1.8px] lg:tracking-[2.16px] uppercase w-full truncate box-border rounded-[20px] py-[9px] disabled:opacity-35 select-none cursor-pointer disabled:cursor-not-allowed transition-colors duration-100 ease-out';

  return (
    <button
      {...buttonProps}
      className={clsx(
        baseClasses,
        {
          'w-auto': length === buttonLengthConstants.AUTO,
          'max-w-[65px] lg:max-w-[96px] px-[9px]': length === buttonLengthConstants.SHORT,
          'max-w-[110px] lg:max-w-[149px] px-[12px]': length === buttonLengthConstants.NORMAL,
          'max-w-[185px] lg:max-w-[202px] px-[15px]': length === buttonLengthConstants.LONG,
          'text-beige-100 bg-cerulean-400 disabled:hover:bg-cerulean-400 hover:shadow-cerulean-400':
            variant === buttonVariantConstants.PRIMARY_CERULEAN,
          'text-beige-100 bg-orange-400 disabled:hover:bg-orange-400 hover:shadow-orange-400':
            variant === buttonVariantConstants.PRIMARY_ORANGE,
          'text-beige-100 bg-purple-400 disabled:hover:bg-purple-400 hover:shadow-purple-400':
            variant === buttonVariantConstants.PRIMARY_PURPLE,
          [`text-cerulean-400 bg-transparent border border-solid border-cerulean-400 hover:text-beige-100
          hover:bg-cerulean-400 disabled:hover:text-cerulean-400 disabled:hover:bg-transparent
          hover:shadow-cerulean-400`]: variant === buttonVariantConstants.SECONDARY_CERULEAN,
          [`text-orange-400 bg-transparent border border-solid border-orange-400 hover:text-beige-100
          hover:bg-orange-400 disabled:hover:text-orange-400 disabled:hover:bg-transparent hover:shadow-orange-400`]:
            variant === buttonVariantConstants.SECONDARY_ORANGE,
          [`text-purple-400 bg-transparent border border-solid border-purple-400 hover:text-beige-100
          hover:bg-purple-400 disabled:hover:text-purple-400 disabled:hover:bg-transparent hover:shadow-purple-400`]:
            variant === buttonVariantConstants.SECONDARY_PURPLE,
          'text-cerulean-400 bg-transparent border-0 hover:text-cerulean-700 disabled:hover:text-cerulean-400':
            variant === buttonVariantConstants.TERTIARY_CERULEAN,
          'text-orange-400 bg-transparent border-0 hover:text-orange-700 disabled:hover:text-orange-400':
            variant === buttonVariantConstants.TERTIARY_ORANGE,
          'text-purple-400 bg-transparent border-0 hover:text-purple-700 disabled:hover:text-purple-400':
            variant === buttonVariantConstants.TERTIARY_PURPLE,
          'hover:bg-cerulean-700': variant === buttonVariantConstants.PRIMARY_CERULEAN && theme !== 'starWars',
          'hover:bg-orange-700': variant === buttonVariantConstants.PRIMARY_ORANGE && theme !== 'starWars',
          'hover:bg-purple-700': variant === buttonVariantConstants.PRIMARY_PURPLE && theme !== 'starWars',
          'hover:bg-cerulean-400': variant === buttonVariantConstants.PRIMARY_CERULEAN && theme === 'starWars',
          'hover:bg-orange-400': variant === buttonVariantConstants.PRIMARY_ORANGE && theme === 'starWars',
          'hover:bg-purple-400': variant === buttonVariantConstants.PRIMARY_PURPLE && theme === 'starWars',
          'hover:shadow-[0_0_20px_5px] transition-shadow duration-[.1s] ease-in-out': theme === 'starWars',
        },
        className,
      )}
      type={type}
    >
      {children}
    </button>
  );
};

ButtonRegular.propTypes = {
  children: node.isRequired,
  className: string,
  length: oneOf(Object.values(buttonLengthConstants)),
  theme: string,
  type: string,
  variant: oneOf(Object.values(buttonVariantConstants)),
};

export default ButtonRegular;
